import { render, staticRenderFns } from "./StepBackButton.vue?vue&type=template&id=67ff9398&scoped=true&"
import script from "./StepBackButton.vue?vue&type=script&lang=js&"
export * from "./StepBackButton.vue?vue&type=script&lang=js&"
import style0 from "./StepBackButton.vue?vue&type=style&index=0&id=67ff9398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ff9398",
  null
  
)

export default component.exports